// Node imports
import { ButtonBaseBehavior, IntroOutroControllerBehavior, SlotAnimationConstant, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist/"
import { gameConstants } from "../Constants/gameConstants";
import { delayedCall, dispatcher, ingenuity, killDelayedCall, Label, Linear, Meter } from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { IntroOutroViewGame } from "./IntroOutroViewGame";

export class IntroOutroControllerGame extends IntroOutroControllerBehavior {
  protected view:IntroOutroViewGame;
  protected totalIntroSpins: Meter;
  protected freeSpinText: Label;

  protected initializeElements(): void {
    super.initializeElements();
    this.OutroWinAmount.angle = gameConstants.OUTRO_AMOUNT_ANGLE;
    this.totalIntroSpins = this.view.getMeterById("totalIntroSpins") as Meter;
    this.freeSpinText = this.view.getLabelById("freeSpinText") as Label;
  }

  protected initializePortraitComponent(): void {
    this.freeGameIntroPortraitSpine = this.view.getSpineById("freespins_intro_Port");
    this.fgOutroPortraitBGSpine = this.view.getSpineById("outroPortraitBG");
  }
  /**
   * Method overrided to Subscribe events
   */
  protected subscribeEvents() {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.ADD_BANNER_ON_TOP, this.view.addOnTop, this.view);
  }
  /**
   * Method overrided to Un Subscribe events
  */
  protected unSubscribeEvents() {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.ADD_BANNER_ON_TOP, this.view.addOnTop, this.view);
  }
  protected showTextAndNumberWithFadeIn(): void {
    this.rotateTextAndNumber();
    this.textAndNumberContainer.visible = true;
    this.textAndNumberContainer.alpha = 0;
    this.totalSpinTriggered.visible = true;
    const fadeInTween = ingenuity.currentGame.add.tween(this.textAndNumberContainer).to({ alpha: 1 }, SlotConstantsBehavior.DURATION_500, Linear.None, true, 500, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      this.view.getContainerByID("taptoclickMessage").visible = true;
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
    this.textAndNumberContainer.angle = gameConstants.INTRO_TEXT_ANGLE;
  }
  protected onIntroShow(): void {
    this.view.getContainerByID("taptoclickMessage").visible = false;
    super.onIntroShow();
    this.continueButton.visible = false;
    this.totalSpinTriggered.setText(String((ingenuity.parserModel as GameParserModel).getFreeSpinNum()) + " " + ingenuity.currentGame.cache.getJSON("lang").free_Spins.text);
    this.alignIntroText();
    dispatcher.fireEvent(eventDispatchers.BURST_SYMBOLS_DESTROY);
  }
  protected alignIntroText(): void {
    // 
  }
  /**
   * Add to play free game intro spine animation
  */
  protected playFreeGameIntroSpine() {
    // dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    if ((ingenuity.parserModel as GameParserModel).getBaseGameTotalWin() === 0) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    }
    this.showTextAndNumberWithFadeIn();
    this.playFgIntroDesktopSpine();
    !ingenuity.deviceEnv.isDesktop && this.playFgIntroPortraitSpine();
  }
  /**
   * to add fade in conitnue
  */
  protected playFgIntroDesktopSpine() {
    this.continueButton.alpha = 0;
    this.continueButton.visible = true;
    const fadeInTween = ingenuity.currentGame.add.tween(this.continueButton).to({ alpha: 1 }, SlotConstantsBehavior.DURATION_500, Linear.None, true, 500, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
    this.disableContinueButton();
    this.playfgIntroBgSpine();
    this.handleFgIntroSounds();
    this.playfgIntroTextSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_INTRO_BLUR_BG);
  }
  protected playFgIntroPortraitSpine() {
    this.playFgIntroPortraitBgSpine();
  }
  protected onPortraitIntroSpinEnds() {
    this.freeGameIntroPortraitSpine.playAnim(SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT, false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.freeGameIntroPortraitSpine.visible = false;
      this.freeGameIntroPortraitSpine.setPause(true);
      this.freeGameIntroPortraitSpine.onComplete.dispose();
    }, this);
  }
  protected hideTextAndNumberWithFadeOut() {
    const fadeOutTween = ingenuity.currentGame.add.tween(this.textAndNumberContainer).to({ alpha: 0 }, 100, Linear.None, true, 0, 0, false);
    fadeOutTween.onComplete.addOnce(() => {
      this.totalSpinTriggered.visible = false;
      fadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(fadeOutTween);
    }, this);
  }
  protected onOutroShow(): void {
    this.OutroContinueBtn.disableAndTint();
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.FREGAME_BGLOOP, key: "soundList_1" });
    super.onOutroShow();
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_BASEGAME);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_FREEGAME);
    dispatcher.fireEvent(eventDispatchers.FG_BURST_SYMBOLS_DESTROY);
  }
  protected startOutroTickup() {
    delayedCall("showOutroWInTickup", 200, () => {
      killDelayedCall("showOutroWInTickup");
      this.startOutroWinAmountTickup();
    }, this);
  }
  protected showFgOutroSpine() {
    this.OutroContinueBtn.alpha = 1;
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstants.UNSCBSCRIBE_METER_CONTROLLERS_FG);
    this.OutroContinueBtn.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
    this.OutroContinueBtn.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUp, this);
    if (this.outroWinAmount) {
      this.OutroContinueBtn.on(ButtonBaseBehavior.UP, this.onOutroContinuePressUp, this);
      this.playFgOutroDesktopSpine();
      !ingenuity.deviceEnv.isDesktop && this.playFgOutroPortraitSpine();
    }
    else {
      this.OutroContinueBtn.on(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG);
      this.showNoWinPopUp();
    }
  }

  protected playFgOutroTextSpine() {
    this.outroTextSpine.setPause(false);
    this.outroTextSpine.onComplete.dispose();
    this.outroTextSpine.visible = true;
    this.outroTextSpine.alpha = 1;
    setTimeout(() => {
      this.outroTextSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_IN, false);
      this.outroTextSpine.onComplete.addOnce(() => {
        this.fgOutroSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_BG_LOOP, true);
        this.outroTextSpine.playAnim(SlotAnimationConstant.FG_OUTRO_DESKTOP_LOOP, true);
      }, this);
    }, 1)

  }
  protected playFgOutroPortraitSpine() {
    this.fgOutroPortraitBGSpine.setPause(false);
    this.fgOutroPortraitBGSpine.visible = true;
    this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_IN, false);
    this.fgOutroPortraitBGSpine.onComplete.addOnce(() => {
      this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP, true);
    }, this);
  }
  protected hideFgOutroPortraitSpine() {
    this.fgOutroPortraitBGSpine.visible = false;
    this.fgOutroPortraitBGSpine.setPause(true);
    this.fgOutroPortraitBGSpine.onComplete.dispose();
  }
  protected onOutroOutSpinEndPortrait() {
    this.fgOutroPortraitBGSpine.playAnim(SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_OUT, false);
  }
  protected onOutroContinuePressUpForNoWin(): void {
    super.onOutroContinuePressUpForNoWin();
    this.OutroContinueBtn.disableAndTint();
    this.OutroContinueBtn.alpha = 0;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BLUR_BG, { name: SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG, duration: 0 });
    this.taptoclickMessageOutro.visible = false;
  }
  /**
   * overrided to change ordering for the hid blur bg
  */
  protected onOutroContinuePressUp() {
    ingenuity.configData.hideBaseGamePortraitButtonPanel = false;
    this.OutroContinueBtn.disableAndTint();
    this.OutroContinueBtn.alpha = 0;
    delayedCall(SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY, 400, () => {
      killDelayedCall(SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY);
      this.resetOutroContinueButton();
      this.stopSoundAndShowBaseGame();
      this.onOutroOutSpinEnd();
      this.fgOutroMeterFadeOut();
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BLUR_BG, { name: SlotConstantsBehavior.FREEGAME_OUTRO_BLUR_BG, duration: 200 });
      delayedCall(SlotConstantsBehavior.OUTRO_HIDE_DELAY, SlotConstantsBehavior.DURATION_1000, () => {
        killDelayedCall(SlotConstantsBehavior.OUTRO_HIDE_DELAY);
        dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
        this.OutroContainer.visible = false;
        this.hideFgOutroSpine();
        !ingenuity.deviceEnv.isDesktop && this.hideFgOutroPortraitSpine();
      }, this);
    }, this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LARGE_STACK_SYMBOL_FG);
  }
}


